import type { Manifest, v4 } from '@sap/ux-specification-types';
import { descriptionSrcURL, syncRule, validity } from '../../../common/decoration/decorators';
import type { CustomFormActionOP } from './ObjectPageFormAction';
import { getActionsPathForOP, getGroupedActionsPathForOP } from '../../application';
import type { ObjectPageCustomActionMenu } from './ObjectPageToolBarAction';

export class ActionAfterExecutionConfigurationForm implements v4.ActionAfterExecutionConfiguration {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getActionsPathForOP(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/2c65f07f44094012a511d6bd83f50f2d')
    navigateToInstance?: boolean;

    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getActionsPathForOP(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    enableAutoScroll?: boolean;
}

export class FormActionBase implements v4.FormActionBase {
    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    afterExecution?: ActionAfterExecutionConfigurationForm;
}

export class FormAction extends FormActionBase implements v4.FormAction {
    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

export class ObjectPageFormActionGroup implements v4.ObjectPageFormActionGroup {
    [key: string]: FormActionBase | number | v4.ActionPriority;

    @syncRule({
        manifest: {
            path: getGroupedActionsPathForOP
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getGroupedActionsPathForOP
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

export class ObjectPageFormActions implements v4.ObjectPageFormActions {
    [key: string]: FormAction | CustomFormActionOP | ObjectPageCustomActionMenu | ObjectPageFormActionGroup;
}

export class ObjectPageForm implements v4.ObjectPageForm {
    actions: ObjectPageFormActions;
}
